import { NgModule } from "@angular/core";
import { PhxTimePickerComponent } from "./phx-time-picker.component";
import { PhxDropdownModule } from "../dropdown/phx-dropdown.module";
import { CommonModule } from "@angular/common";
import { PhxButtonModule } from "../button/phx-button.module";
import { PhxTimePickerPanelComponent } from "./phx-time-picker-panel.component";
import { FormsModule } from "@angular/forms";
import { PhxInputModule } from "../input/phx-input.module";
import { PhxTimePickerInputComponent } from "./phx-time-picker-input.component";
import { PhxIconModule } from '../icon/icon.module';
import { PhxTileModule } from "../tile/phx-tile.module";

@NgModule({
  declarations: [
    PhxTimePickerComponent,
    PhxTimePickerPanelComponent,
    PhxTimePickerInputComponent,
  ],
  imports: [
    CommonModule,
    PhxDropdownModule,
    PhxTileModule,
    PhxButtonModule,
    PhxInputModule,
    PhxIconModule,
    FormsModule,
  ],
  exports: [PhxTimePickerComponent, PhxTimePickerInputComponent],
})
export class PhxTimePickerModule {
}